import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

export * from './types'
export * from 'yet-another-react-lightbox'

export { default } from './Lightbox'
